import loadable from '@loadable/component';

export const PoweredBy = loadable(() => import(/* webpackChunkName: 'powered-by' */ './PoweredBy'));
